import styled from '@emotion/styled';
import { MenuItem } from '@mui/material';

export const StickyMenuItem = styled(MenuItem)({
  position: 'sticky',
  bottom: 0,
  ':hover': {
    backgroundColor: '#B3C2DA',
  },
});
